import { render, staticRenderFns } from "./NewsEditDialog.vue?vue&type=template&id=4c4c1123"
import script from "./NewsEditDialog.js?vue&type=script&lang=js&external"
export * from "./NewsEditDialog.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports